// extracted by mini-css-extract-plugin
export default {"card":"TransactionListMobile_card__So2vT","gridContainer":"TransactionListMobile_gridContainer__pSZX5","title":"TransactionListMobile_title__y4i42"};